(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/company-details/components/company-details-form/company-details-form.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/company-details/components/company-details-form/company-details-form.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useContext = _React.useContext,
  useEffect = _React.useEffect,
  Fragment = _React.Fragment,
  useState = _React.useState;
const _svs$ticket_partner$c = svs.ticket_partner.companyDetails.constants.actions,
  RECEIVE_COMPANY_DETAILS = _svs$ticket_partner$c.RECEIVE_COMPANY_DETAILS,
  EDIT_MODE = _svs$ticket_partner$c.EDIT_MODE;
const _svs$ticket_partner$c2 = svs.ticket_partner.companyDetails.constants.TEXTS,
  HEADER = _svs$ticket_partner$c2.HEADER,
  EDIT_LABEL = _svs$ticket_partner$c2.EDIT_LABEL,
  CANCEL_LABEL = _svs$ticket_partner$c2.CANCEL_LABEL,
  SAVE_LABEL = _svs$ticket_partner$c2.SAVE_LABEL,
  SAVE_SUCCESS = _svs$ticket_partner$c2.SAVE_SUCCESS;
const GridCol = svs.ui.ReactGrid.GridCol;
const Form = svs.ui.reactForm.Form;
const _svs$ticket_partner$c3 = svs.ticket_partner.companyDetails.components.companyDetailsForm.components,
  ContactPerson = _svs$ticket_partner$c3.ContactPerson,
  Addresses = _svs$ticket_partner$c3.Addresses;
const ButtonRow = svs.ticket_partner.sharedComponents.buttonRow.ButtonRow;
const mapUpdateCompanyCustomerError = svs.ticket_partner.services.mapUpdateCompanyCustomerError;
const createUpdateCompanyCustomerRequest = svs.ticket_partner.companyDetails.utils.createUpdateCompanyCustomerRequest;
const CompanyDetails = _ref => {
  let handleSubmit = _ref.handleSubmit;
  const _useContext = useContext(svs.ticket_partner.CompanyDetailsContext),
    dispatch = _useContext.dispatch,
    state = _useContext.state;
  const edit = state.companyDetails.edit;
  const _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    beforeEditState = _useState2[0],
    setBeforeEditState = _useState2[1];
  const passwordEdit = state.password.edit;
  const saveAndCancelBtns = [{
    className: 'margin-right-1',
    label: CANCEL_LABEL,
    key: 'cancel-btn',
    transparent: true,
    onClick: e => {
      e.preventDefault();
      dispatch({
        type: EDIT_MODE,
        payload: {
          edit: false,
          beforeEditState
        }
      });
    }
  }, {
    label: SAVE_LABEL,
    key: 'save-btn',
    inverted: true,
    type: 'submit'
  }];
  const editBtn = [{
    label: EDIT_LABEL,
    key: 'edit-btn',
    inverted: true,
    onClick: e => {
      e.preventDefault();
      setBeforeEditState(state.companyDetails);
      dispatch({
        type: EDIT_MODE,
        payload: {
          edit: true
        }
      });
    }
  }];
  if (passwordEdit) {
    return null;
  }
  return edit ? React.createElement(Form, {
    onSubmit: handleSubmit
  }, React.createElement(ContactPerson, null), React.createElement(Addresses, null), React.createElement(ButtonRow, {
    buttons: saveAndCancelBtns,
    className: "margin-top-2 margin-bottom-2"
  })) : React.createElement(Fragment, null, React.createElement(ContactPerson, null), React.createElement(Addresses, null), React.createElement(ButtonRow, {
    buttons: editBtn,
    className: "margin-top-2"
  }));
};
const CompanyDetailsForm = () => {
  const _svs$ticket_partner$u = svs.ticket_partner.useUserContext(),
    companyDetailsPromise = _svs$ticket_partner$u.companyDetailsPromise;
  const _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    fetchingDetails = _useState4[0],
    setFetchingDetails = _useState4[1];
  const _useContext2 = useContext(svs.ticket_partner.CompanyDetailsContext),
    dispatch = _useContext2.dispatch,
    state = _useContext2.state;

  useEffect(async () => {
    svs.ui.loader.show();
    const _await$companyDetails = await companyDetailsPromise,
      companyDetails = _await$companyDetails.companyDetails;
    if (companyDetails) {
      dispatch({
        type: RECEIVE_COMPANY_DETAILS,
        payload: _objectSpread({}, companyDetails)
      });
    }
    svs.ui.loader.hide();
    setFetchingDetails(false);
  }, [companyDetailsPromise]);
  const handleSubmit = async (e, formData) => {
    e === null || e === void 0 || e.preventDefault();
    if (_.values(formData).some(_ref2 => {
      let isValid = _ref2.isValid;
      return !isValid;
    })) {
      return;
    }
    svs.ui.loader.show();
    const requestData = createUpdateCompanyCustomerRequest(state);
    try {
      await svs.ticket_partner.services.updateCompanyCustomer(requestData);
      dispatch({
        type: EDIT_MODE,
        payload: {
          edit: false
        }
      });
      svs.ticket_partner.utils.showSuccessDialog('', SAVE_SUCCESS);
    } catch (e) {
      const errorMessage = mapUpdateCompanyCustomerError(e);
      svs.ticket_partner.utils.showErrorDialog(errorMessage);
    }
    svs.ui.loader.hide();
  };
  return React.createElement(GridCol, {
    className: "u-text-left",
    md: 6,
    sm: 12
  }, React.createElement("h1", null, HEADER), !fetchingDetails ? React.createElement(CompanyDetails, {
    handleSubmit: handleSubmit
  }) : null);
};
svs.ticket_partner.companyDetails.components.CompanyDetailsForm = CompanyDetailsForm;

 })(window);